import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "table-container overflow-x-auto" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { "data-label": "Name" }
const _hoisted_5 = { "data-label": "Email" }
const _hoisted_6 = { "data-label": "Age" }
const _hoisted_7 = { "data-label": "Action" }
const _hoisted_8 = { class: "flex justify-end space-x-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_12 = {
  key: 1,
  class: "modal-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserForm = _resolveComponent("UserForm")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_UserActionPopup = _resolveComponent("UserActionPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "table-header" }, [
            _createElementVNode("th", {
              scope: "col",
              class: "rounded-tl-md"
            }, "Name"),
            _createElementVNode("th", { scope: "col" }, "Email"),
            _createElementVNode("th", { scope: "col" }, "Age"),
            _createElementVNode("th", {
              scope: "col",
              class: "table-cell rounded-tr-md"
            }, "Action")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: user.id,
              class: "table-row",
              scope: "row"
            }, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(user.name), 1),
              _createElementVNode("td", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "status-indicator" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(user.email), 1)
              ]),
              _createElementVNode("td", _hoisted_6, _toDisplayString(user.age), 1),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "action-button",
                    onClick: ($event: any) => (_ctx.editUser(user))
                  }, "Edit", 8, _hoisted_9),
                  _createElementVNode("button", {
                    class: "action-button",
                    onClick: ($event: any) => (_ctx.openDeleteModal(user.id))
                  }, "Delete", 8, _hoisted_10)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_Modal, { "modal-title": _ctx.modalTitle }, {
              default: _withCtx(() => [
                _createVNode(_component_UserForm, {
                  "user-info": _ctx.userPathName ? {} : _ctx.userInfo,
                  onSubmit: _ctx.submitUser
                }, null, 8, ["user-info", "onSubmit"])
              ]),
              _: 1
            }, 8, ["modal-title"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_UserActionPopup, {
              onSetSubmit: _ctx.deleteUser,
              onCancelSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteModal = false)),
              question: "Are you sure you want to delete this user?"
            }, null, 8, ["onSetSubmit"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}